import { cn } from "../lib/utils";
import { useLanguage } from "../contexts/LanguageContext";
import type { Loc, Role } from "../../../shared/const";

interface Props {
  className?: string;
  showSubtitle?: boolean;
  /** D6：依角色顯示品牌名；未帶（登入前）顯示 DreamTour */
  role?: Role;
}

/**
 * D6 品牌名稱依角色（中文已定；英文業主採建議名）。副標一律 DreamTour（D9 品牌）。
 * agency＝客戶訂車平台 / Client Booking；dispatcher・admin＝調度員平台 / Dispatcher Console；
 * fleet＝供應商平台 / Supplier Console。
 */
const BRAND_BY_ROLE: Record<Role, Loc> = {
  agency: { "zh-TW": "客戶訂車平台", "en-US": "Client Booking", "zh-CN": "客户订车平台" },
  dispatcher: { "zh-TW": "調度員平台", "en-US": "Dispatcher Console", "zh-CN": "调度员平台" },
  admin: { "zh-TW": "調度員平台", "en-US": "Dispatcher Console", "zh-CN": "调度员平台" },
  fleet: { "zh-TW": "供應商平台", "en-US": "Supplier Console", "zh-CN": "供应商平台" },
};

export function Wordmark({ className, showSubtitle = true, role }: Props) {
  const { t } = useLanguage();
  const main = role ? t(BRAND_BY_ROLE[role]) : "DreamTour";
  const sub = role ? "DreamTour" : "Dream Tour";
  return (
    <div className={cn("flex flex-col leading-none", className)}>
      <span className="font-display text-[20px] font-medium tracking-tight">{main}</span>
      {showSubtitle && (
        <span className="mt-0.5 font-mono text-[12px] uppercase tracking-[0.18em] text-muted-foreground">{sub}</span>
      )}
    </div>
  );
}

/** D9：DreamTour 去背 logo 圖（登入頁/頁尾用）。素材由名片萃取。 */
export function LogoImage({ className }: { className?: string }) {
  return <img src="/dreamtour-logo.png" alt="DreamTour" className={cn("h-auto w-auto", className)} />;
}
